import { UserEntityInterface } from '@types';

export const getUserFullNameInitials = (user: UserEntityInterface): string => {
  if (!user) {
    return null;
  }
  return user.firstName[0] + user.lastName[0];
};
